import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const linkBtnDefaultVariants = {}
const linkBtnCompoundVariants = []

const linkBtnSlotNames = [
  [
    "link",
    "link-btn__link"
  ],
  [
    "btn",
    "link-btn__btn"
  ]
]
const linkBtnSlotFns = /* @__PURE__ */ linkBtnSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, linkBtnDefaultVariants, getSlotCompoundVariant(linkBtnCompoundVariants, slotName))])

const linkBtnFn = memo((props = {}) => {
  return Object.fromEntries(linkBtnSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const linkBtnVariantKeys = []
const getVariantProps = (variants) => ({ ...linkBtnDefaultVariants, ...compact(variants) })

export const linkBtn = /* @__PURE__ */ Object.assign(linkBtnFn, {
  __recipe__: false,
  __name__: 'linkBtn',
  raw: (props) => props,
  variantKeys: linkBtnVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, linkBtnVariantKeys)
  },
  getVariantProps
})